module.exports = __webpack_public_path__ + "img/lb-alert.a56f69b6.svg";